// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1BVTr","location":"Header_location__RbgYm"};